<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'usuario-cargo') {
            next({ name: 'usuario-cargo-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'usuario-cargo') {
            this.$router.push({ name: 'usuario-cargo-list' });
        }
    },
};
</script>
